import React from "react";
import "./ExportProcess.css";
import { FaBox, FaShip, FaPlane, FaHome } from "react-icons/fa"; // Import Icons

const exportSteps = [
  { icon: <FaBox />, title: "Step 1: Order Confirmation", description: "We confirm your order details and prepare the items." },
  { icon: <FaShip />, title: "Step 2: Shipment Processing", description: "Your products are packed and ready for shipment." },
  { icon: <FaPlane />, title: "Step 3: Export & Delivery", description: "We ensure timely export and safe delivery to your location." },
  { icon: <FaHome />, title: "Step 4: Arrival & Setup", description: "Receive your items and set them up with ease." }
];

const ExportProcess = () => {
  return (
    <section className="export-process">
      <h2>Our Export Process</h2>
      <div className="export-timeline">
        {exportSteps.map((step, index) => (
          <div key={index} className="export-step">
            <div className="export-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExportProcess;
